module.exports = __webpack_public_path__ + "static/img/interface_en@2x.e71ec39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interface_en@2x.png
// module id = Wefl
// module chunks = 1